export const getSavePreferencesPayload = ({ mentionsNotifications, storeByDefault, storePreferences }) => ({
  mentions_notifications: mentionsNotifications,
  default_store_id: storeByDefault === 'null' ? null : storeByDefault,
  store_preferences: storePreferences?.map(store => ({
    store_id: store.store_id,
    default_restock_location_id: store.default_restock_location_id,
  })),
})

export const getDefaultRestockLocation = (storePreferences, storeId) => {
  return storePreferences?.find(store => store.store_id === storeId)?.default_restock_location_id || null
}
